import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9e2f440"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "nav-buttons" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-tablet-move" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-tablet-add" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-label-add" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-edit" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "nav-btn",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('open-case-selector')), ["prevent"]))
          }, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.add.to.case')), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "nav-btn",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('on-create-new-case')), ["prevent"]))
          }, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.new.case')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["nav-btn", { disabled: _ctx.isNetwork || !_ctx.isMy }]),
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('on-labels')), ["prevent"]))
      }, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.labels')), 1)
      ], 2),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('on-edit')), ["prevent"])),
        class: _normalizeClass([{ disabled: !_ctx.showEdit || !_ctx.isMy }, "nav-btn"])
      }, [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.edit')), 1)
      ], 2)
    ])
  ]))
}